import * as Sentry from "@sentry/react";
import { AmaiDiscussit } from "./components/amai-discussit.jsx";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      /* eslint-disable-next-line no-undef */
      filterKeys: [__SENTRY_APPLICATION_KEY__],
      behaviour: "drop-error-if-exclusively-contains-third-party-frames",
    }),
  ],
});

AmaiDiscussit.register();
